import axios from 'axios'
const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const HAS_AUTH = process.env.REACT_APP_HAS_AUTH === "true";
const BASE_AUTH_URL = `${BASE_URL}api/accounts/`;
const KEY = "Authorization";

axios.interceptors.request.use(function (config) {
    config.headers["ApiKey"] = localStorage.getItem(KEY);
    return config;
});

axios.interceptors.response.use(function (response) { return response },
    function (error) {
        if (error.response && error.response.status === 401) {
            AuthService().logout();
            window.location.reload();
        } else {
            return Promise.reject(error);
        }
    });

const AuthService = () => ({

    login: async (credentials) => {
        const { data } = await axios.post(`${BASE_AUTH_URL}Login`, credentials);
        if (data)
            localStorage.setItem(KEY, data);

        return data;
    },

    logout: () => {
        localStorage.removeItem(KEY);
    },

    isAuthenticated: async () => {
        if (!HAS_AUTH)
            return true;

        const token = localStorage.getItem(KEY);
        if (!token)
            return false;

        const response = await axios.post(`${BASE_AUTH_URL}Validate?token=${token}`);
        return response.status = 200 && response.data === true;
    }

});

export default AuthService;